import { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
import { api } from "../api/api";

const KEY = "ueberuns_content";
const DEF = {
  hofText: "Der Milchbauernhof Gehrke ist ein familiengeführter Betrieb mit langer Tradition. Seit über 80 Jahren bewirtschaften wir unser Land mit Leidenschaft und Respekt vor der Natur. Was als kleiner Bauernhof begann, ist heute ein moderner Milchwirtschaftsbetrieb – ohne dabei unsere Wurzeln zu vergessen.",
  k1titel: "🌿 Natürlich & Regional", k1text: "Unsere Kühe grasen auf saftigen Wiesen der Region. Kein langer Transport, keine unnötigen Zusatzstoffe – nur pure Frische direkt vom Hof.",
  k2titel: "👨‍👩‍👧 Familienbetrieb",    k2text: "Bei uns arbeitet die ganze Familie mit. Jedes Produkt entsteht mit Sorgfalt und dem Wissen, das von Generation zu Generation weitergegeben wird.",
  k3titel: "🏆 Qualität zuerst",       k3text: "Regelmäßige Qualitätskontrollen und kurze Produktionswege garantieren höchste Frische und Qualität bei jedem unserer Produkte.",
  k4titel: "🎒 Schulbelieferung",      k4text: "Wir beliefern Schulen und Kindergärten in der Region mit frischer Hofmilch und anderen Produkten – zuverlässig, regelmäßig und direkt vom Erzeuger.",
  oz1label: "Montag – Freitag", oz1zeit: "07:00 – 18:00 Uhr",
  oz2label: "Samstag",          oz2zeit: "07:00 – 14:00 Uhr",
  oz3label: "Sonntag",          oz3zeit: "Geschlossen",
};
const KARTEN = ["k1", "k2", "k3", "k4"];
const OZ = ["oz1", "oz2", "oz3"];

export default function UeberUns() {
  const { user } = useAuth();
  const isAdmin = !!user?.isAdmin;
  const [content, setContent] = useState(DEF);
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState(DEF);
  const [msg, setMsg] = useState(null);

  useEffect(() => {
    api.einstellungen.get(KEY).then(r => { if (r) setContent(typeof r === "string" ? JSON.parse(r) : r); }).catch(() => {});
  }, []);

  async function save() {
    try {
      await api.einstellungen.update(KEY, JSON.stringify(draft));
      setContent(draft);
      setEditing(false);
      setMsg("✓ Gespeichert!");
      setTimeout(() => setMsg(null), 3000);
    } catch { setMsg("Fehler beim Speichern."); }
  }

  const set = k => e => setDraft(d => ({ ...d, [k]: e.target.value }));
  const c = editing ? draft : content;

  return (
    <div className="container" style={{ maxWidth: 800 }}>
      <h2 className="section-title" style={{ marginTop: "1rem" }}>Über uns</h2>
      {msg && <p style={{ color: msg.startsWith("✓") ? "green" : "red", margin: "0.5rem 0" }}>{msg}</p>}

      <div className="card" style={{ marginTop: "1.5rem", lineHeight: "1.9" }}>
        <h3 style={{ color: "#2e7d32", marginBottom: "0.75rem" }}>🐄 Unser Hof – seit Generationen</h3>
        {editing
          ? <textarea rows={4} value={draft.hofText} onChange={set("hofText")} style={TA} />
          : <p style={{ color: "#555" }}>{c.hofText}</p>
        }
      </div>

      <div className="card-grid" style={{ marginTop: "1.5rem" }}>
        {KARTEN.map(k => (
          <div key={k} className="card" style={{ border: "1.5px solid #a5d6a7" }}>
            {editing ? (
              <>
                <input value={draft[k + "titel"]} onChange={set(k + "titel")} style={IN} />
                <textarea rows={3} value={draft[k + "text"]} onChange={set(k + "text")} style={TA} />
              </>
            ) : (
              <>
                <h3>{c[k + "titel"]}</h3>
                <p style={{ color: "#555", marginTop: "0.5rem" }}>{c[k + "text"]}</p>
              </>
            )}
          </div>
        ))}
      </div>

      <div className="card" style={{ marginTop: "1.5rem", lineHeight: "1.9" }}>
        <h3 style={{ color: "#2e7d32", marginBottom: "0.75rem" }}>🕐 Öffnungszeiten Hofladen</h3>
        <table style={{ width: "100%", borderCollapse: "collapse" }}>
          <tbody>
            {OZ.map(oz => (
              <tr key={oz} style={{ borderBottom: "1px solid #e0e0e0" }}>
                <td style={{ padding: "0.6rem 0", fontWeight: 600, width: "55%" }}>
                  {editing
                    ? <input value={draft[oz + "label"]} onChange={set(oz + "label")} style={{ ...IN, marginBottom: 0 }} />
                    : c[oz + "label"]
                  }
                </td>
                <td style={{ padding: "0.6rem 0", color: "#555" }}>
                  {editing
                    ? <input value={draft[oz + "zeit"]} onChange={set(oz + "zeit")} style={{ ...IN, fontWeight: "normal", marginBottom: 0 }} />
                    : c[oz + "zeit"]
                  }
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {isAdmin && !editing && (
        <button className="btn btn-secondary" style={{ marginTop: "1.5rem" }}
          onClick={() => { setDraft(content); setEditing(true); setMsg(null); }}>
          ✏️ Seite bearbeiten
        </button>
      )}
      {editing && (
        <div style={{ display: "flex", gap: "0.5rem", marginTop: "1.5rem" }}>
          <button className="btn btn-primary" onClick={save}>Speichern</button>
          <button className="btn btn-secondary" onClick={() => setEditing(false)}>Abbrechen</button>
        </div>
      )}
    </div>
  );
}

const TA = { width: "100%", padding: "0.4rem", borderRadius: 5, border: "1px solid #ccc", fontSize: "0.9rem", marginBottom: "0.25rem", resize: "vertical", fontFamily: "inherit" };
const IN = { width: "100%", padding: "0.4rem", borderRadius: 5, border: "1px solid #ccc", fontSize: "1rem", marginBottom: "0.25rem", fontFamily: "inherit", fontWeight: 600 };
